import React from 'react';
var cdn_base_url = "//api.smartzk.cn";
var cdn_base_url_2 = "//api.smartzk.cn";
String.prototype.startWith=function(str){
    var reg=new RegExp("^"+str);
    return reg.test(this);
}
export default {
    //获取图片的主色调和互补色
    async getImageColor(src,func){
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src=src;
        console.log(img)
        var bgColor=[];
        var canvas = document.createElement('canvas');
        img.onload = function() {
            var ctx = canvas.getContext("2d");
            const {width, height} = img;
            const scaleRect = width * height;
            let sum_r = 0, sum_g = 0, sum_b = 0;
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0);
            var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            console.log(imgData)
            for (let i = 0; i < imgData.data.length; i += 4) {
                const r = imgData.data[i];
                const g = imgData.data[i + 1];
                const b = imgData.data[i + 2];
                sum_r += r;
                sum_g += g;
                sum_b += b;
            }
            const avg_r = Math.round(sum_r / scaleRect);
            const avg_g = Math.round(sum_g / scaleRect);
            const avg_b = Math.round(sum_b / scaleRect);
            const u_r = 255-avg_r;
            const u_g = 255-avg_g;
            const u_b = 255-avg_b;
            console.log(avg_r, avg_g, avg_b)
            const a = 0.8;
            bgColor = [`rgba(${avg_r},${avg_g},${avg_b},${a})`, `rgb(${u_r},${u_g},${u_b})`];
            console.log(bgColor)
            func(bgColor);
        }
    },
    //获取时间年月日，并转为英文
    getNowTime(time){
        let dt = time;
        let m=new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Spt","Oct","Nov","Dec");
        let w=new Array("Monday","Tuseday","Wednesday","Thursday","Friday","Saturday","Sunday");
        let d=new Array("st","nd","rd","th");
        let mn=dt.getMonth();
        let wn=dt.getDay();
        let dn=dt.getDate();
        let dns;
        if(((dn)<1) ||((dn)>3)){
            dns=d[3];
        } else {
            dns=d[(dn)-1];
            if((dn==11)||(dn==12)){
                dns=d[3];
            }
        }
        let dates = [dn+dns,m[mn],dt.getFullYear()];
        return dates
    },
    //图片地址
    getUrl(url) {
        if(url==null||url==""||typeof(url)=="undefined"){
            return url;
        }
        if(url.startWith("uploads")){
            return cdn_base_url+url;
        }else if(url.startWith("/uploads")){
            return cdn_base_url+url;
        }else if(url.startWith("upload")){
            return cdn_base_url_2+url;
        }else if(url.startWith("/upload")){
            return cdn_base_url_2;
        }else{
            return url;
        }
}
};



